import { AreaType } from '../store/navigation.type';

export const determineSelectionFromPath = (): AreaType => {
  if (window.location.pathname.includes('/erhverv')) {
    return 'commercial';
  } else if (window.location.pathname.includes('/landbrug')) {
    return 'agriculture';
  } else {
    return 'private';
  }
};
